'use client';

import { useSet } from '@mantine/hooks';
import { type PropsWithChildren, createContext, useContext, useState } from 'react';
export enum STATUS {
  REGISTRATION = 'registration',
  VERIFY_EMAIL = 'verify_email',
  COMPLETE_PROFILE = 'complete_profile',
  ID_VERIFICATION = 'id_verification',
}
export type Successes = Set<STATUS | null>;
export type VerifyActionContextProps = {
  status: STATUS | null;
  successes: Successes;
  setVerifyStatus: (status: STATUS | null) => void;
};
const VerifyActionContext = createContext<VerifyActionContextProps | null>(null);
export const VerifyActionProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [status, setVerifyStatus] = useState<STATUS | null>(STATUS.REGISTRATION);
  const successes = useSet<STATUS | null>([STATUS.REGISTRATION]);
  return <VerifyActionContext.Provider value={{
    status,
    successes,
    setVerifyStatus
  }}>
      {children}
    </VerifyActionContext.Provider>;
};
export const useVerifyAction = () => {
  const context = useContext(VerifyActionContext);
  if (!context) {
    throw new Error('useVerifyAction must be used within a VerifyActionProvider');
  }
  return context;
};